import { usePaginatedQuery, captureException } from '@playbookux/playbook-web-core';
import useDebounce from '../use-debounce';
import typeEntity from '../../constants/entity-type';
import { SearchTypes, optionsIncludes } from './helper';

import {
  GET_SEARCH,
  DEBOUNCE_TIME,
  LIMIT,
  SKIP,
} from './graphql';

const UseSearch = (
  companyId,
  searchInput,
  selectedProjects,
  activeItem,
) => {
  const [debouncedSearch] = useDebounce(() => searchInput, DEBOUNCE_TIME, [searchInput]);

  const NoteType = {
    [SearchTypes.NOTES]: [typeEntity.TEST_SESSION_NOTE],
    [SearchTypes.CLIPS]: [typeEntity.TEST_SESSION_CLIP],
    [SearchTypes.HIGHLIGHTS]: [typeEntity.TAG_HIGHLIGHT],
    [SearchTypes.REPORTS]: [typeEntity.REPORT],
    [SearchTypes.TRANSCRIPTS]: [typeEntity.TEST_SESSION_ANSWER, typeEntity.TEST_SESSION_SPEAKER],
    [SearchTypes.ALL]: [
      typeEntity.TEST_SESSION_NOTE,
      typeEntity.TEST_SESSION_CLIP,
      typeEntity.REPORT,
      typeEntity.TAG_HIGHLIGHT,
      typeEntity.TEST_SESSION_ANSWER,
      typeEntity.TEST_SESSION_SPEAKER,
    ],
  };

  const attributes = {
    variables: {
      companyId,
      projectIds: selectedProjects || [],
      searchableType: NoteType[activeItem],
      search: debouncedSearch || null,
      limit: LIMIT,
      offset: SKIP,
      ...optionsIncludes(activeItem),
      fetchPolicy: 'network-only',
    },
  };

  const {
    error,
    loading,
    data: dataSearch = {},
    fetchMore,
    hasMore,
  } = usePaginatedQuery(GET_SEARCH, attributes, { dataField: 'search' });

  if (error) {
    captureException('USE_SEARCH_FAILED', error);
  }

  return {
    error,
    loading,
    dataSearch,
    fetchMore,
    hasMore,
  };
};

export default UseSearch;
